module.exports = {
  belts: 'belts',
  levels: 'levels',
  levelsToNumbers: {
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6
  },
  levelsHash: {
    one: 'one',
    two: 'two',
    three: 'three',
    four: 'four',
    five: 'five',
    six: 'six'
  },
  gifs: {
    up: 'up',
    out: 'out',
    talk: 'talk',
    static: 'static'
  },
  white: 'white',
  black: 'black',
  exit: 'exit',
  wordSound: 'wordSound',
  hover: 'hover',
  activate: 'activate',
  back: 'back',
  yes: 'yes',
  no: 'no',
  yesPic: 'yesPic',
  noPic: 'noPic',
  success: 'success',
  levelsArr: ['one', 'two', 'three', 'four', 'five', 'six'],
  beltsArr: ['white', 'yellow', 'orange', 'green', 'blue', 'black'],
  beltsCodes: {
    // belts key: [belts to unlock]
    // for example, code blue will result in unlocking all levels except the blue one, since its the blue belt's code.
    yellow: {
      beltColor: 'yellow',
      beltsToUnlockArr: ['white']
    },
    orange: {
      beltColor: 'orange',
      beltsToUnlockArr: ['white', 'yellow']
    },
    green: {
      beltColor: 'green',
      beltsToUnlockArr: ['white', 'yellow', 'orange']
    },
    blue: {
      beltColor: 'blue',
      beltsToUnlockArr: ['white', 'yellow', 'orange', 'green']
    },
    black: {
      beltColor: 'black',
      beltsToUnlockArr: ['white', 'yellow', 'orange', 'green', 'blue', 'black']
    }
  },
  eventTypes: {
    HOVER: 'HOVER',
    UNHOVER: 'UNHOVER',
    ACTIVATE: 'ACTIVATE'
  },
  vowelBodyParts: {
    VOWEL_I: ['rightHip', 'leftHip', 'rightWrist', 'leftWrist'],
    VOWEL_A: [
      'rightWrist',
      'leftWrist',
      'rightShoulder',
      'leftShoulder',
      'leftElbow',
      'rightElbow'
    ],
    VOWEL_O: [
      'rightWrist',
      'leftWrist',
      'rightShoulder',
      'leftShoulder',
      'leftElbow',
      'rightElbow'
    ],
    VOWEL_U: [
      'rightWrist',
      'leftWrist',
      'rightShoulder',
      'leftShoulder',
      'leftElbow',
      'rightElbow',
      'leftHip',
      'rightHip'
    ],
    VOWEL_SHVA: [
      'rightWrist',
      'leftWrist',
      'rightShoulder',
      'leftShoulder',
      'leftHip',
      'rightHip'
    ],
    VOWEL_E: [
      'rightWrist',
      'leftWrist',
      'rightShoulder',
      'leftShoulder',
      'leftHip',
      'rightHip'
    ]
  },
  vowels: {
    VOWEL_O: 'VOWEL_O',
    VOWEL_I: 'VOWEL_I',
    VOWEL_E: 'VOWEL_E',
    VOWEL_A: 'VOWEL_A',
    VOWEL_SHVA: 'VOWEL_SHVA',
    VOWEL_U: 'VOWEL_U'
  },
  vowelFunctions: {
    VOWEL_O: 'detectionProcessVowelO',
    VOWEL_I: 'detectionProcessVowelI',
    VOWEL_E: 'detectionProcessVowelE',
    VOWEL_A: 'detectionProcessVowelA',
    VOWEL_SHVA: 'detectionProcessVowelShva',
    VOWEL_U: 'detectionProcessVowelU'
  },

  // https://codepoints.net/hebrew
  // http://www.unicode.org/charts/PDF/U0590.pdf
  regexes: {
    vowelsRegex: /[\u0591-\u05C7]/,
    shinRegex: /[\u05e9]/,
    vavRegex: /[\u05d5]/,
    correctDageshLettersRegex: /[\u05EA|\u05E4]/, // ת, פ
    VOWEL_A: /[\u05b8|\u05b7|\u05b3|\u05b2]/,
    VOWEL_E: /[\u05b6|\u05b5|\u05b1]/,
    VOWEL_O: /[\u05ba|\u05b9]/,
    VOWEL_U: /[\u05bb]/,
    VOWEL_U_VAV: /[\u05bC]/,
    VOWEL_I: /[\u05b4]/,
    VOWEL_SHVA: /[\u05b0]/
  }
};
